import { useEffect, useMemo, useState } from "react";
import { useData } from "@/context/DataContext";
import { api, errMsg } from "@/lib/api";
import { ActivityForm } from "@/components/activity/ActivityForm";
import { ActivityList } from "@/components/activity/ActivityList";

export default function ActivityPage() {
  const { reps, repsById, leads } = useData();
  const [entries, setEntries] = useState([]);
  const [error, setError] = useState("");
  const [setterFilter, setSetterFilter] = useState("");

  useEffect(() => {
    api.get("/activity").then((r) => setEntries(r.data)).catch((e) => setError(errMsg(e, "Could not load activity")));
  }, [leads]);

  const onSaved = (a) => setEntries((es) => [a, ...es.filter((x) => x.id !== a.id)].sort((x, y) => y.date.localeCompare(x.date)));
  const visible = useMemo(() => entries.filter((a) => !setterFilter || a.setter_id === setterFilter), [entries, setterFilter]);
  const setterReps = reps.filter((r) => ["Setter", "Both"].includes(r.role));

  return (
    <div className="space-y-5" data-testid="activity-page">
      <div>
        <h1 className="font-display text-2xl font-extrabold tracking-tight sm:text-3xl">Daily activity</h1>
        <p className="text-sm text-slate-400">One entry per setter per day. Saving again for the same day updates it.</p>
      </div>
      <ActivityForm reps={reps} entries={entries} onSaved={onSaved} />
      {error && <p className="text-sm text-amber-400">{error}</p>}
      <div className="flex items-center justify-between gap-3">
        <p data-testid="activity-count" className="font-mono text-xs text-slate-400">{visible.length} entries</p>
        <select data-testid="activity-filter-setter" value={setterFilter} onChange={(e) => setSetterFilter(e.target.value)} className="inp w-48">
          <option value="">All setters</option>
          {setterReps.map((r) => <option key={r.id} value={r.id}>{r.name}</option>)}
        </select>
      </div>
      <ActivityList entries={visible} repsById={repsById} onDelete={(id) => setEntries((es) => es.filter((x) => x.id !== id))} />
    </div>
  );
}
